import React from "react";
import { Link, useParams } from "react-router-dom";
import Blog from "./Blog";
import RelatedPosts from "./RelatedPosts";

export default function DetailsBlog() {
  // const { blog, isLoading, isError, error } = useSelector(
  //   (state) => state.blog
  // );
  const { blogId } = useParams();
  // const dispatch = useDispatch();

  // const { id, tags } = blog || {};

  // useEffect(() => {
  //   dispatch(fetchBlog(blogId));
  // }, [dispatch, blogId]);

  // decide what to render
  // let content = null;
  // if (isLoading) content = <Loading />;

  // if (!isLoading && isError)
  //   content = <div className="col-span-12">{error}</div>;

  // if (!isLoading && !isError && !blog?.id) {
  //   content = <div className="col-span-12">No Blog found!</div>;
  // }
  // if (!isLoading && !isError && blog?.id) {
  //   content = (
  //   <>
  //     {/* <!-- detailed post  --> */}
  //     {/* <Blog blog={blog} /> */}
  //     {/* <!-- detailed post ends --> */}
  //     {/* <!-- related posts --> */}
  //     {/* <RelatedPosts currentVideoId={id} tags={tags} /> */}
  //     {/* <!-- related posts ends --> */}
  //   </>
  // );
  // }
  return (
    <>
      {/* <!-- Go Home / Go Back --> */}
      <div className="container mt-8">
        <Link
          to="/"
          className="inline-block text-gray-600 home-btn"
          id="lws-goHome"
        >
          <i className="mr-2 fa-solid fa-house"></i>Go Home
        </Link>
      </div>
      <section className="post-page-container">
        {/* {content} */}
        <Blog blogId={blogId} />
        <RelatedPosts />
      </section>
    </>
  );
}
